module.exports = __webpack_public_path__ + "static/media/animeCharacter.7b635a1d.png";